import * as React from "react";
import { useTranslation } from 'react-i18next';

const fields = {

        config: { columns: 1 },
        fields: [
            {
                name: "toolType",
                label: "formConfig.toolType",
                column: 1,
                type: "enum",
                enumType: "enums/toolType",
            },
            {
                name: "toolNumber",
                label: "formConfig.toolNumber",
                column: 1,
            },
            {
                name: "labelling",
                label: "formConfig.labeling",
                column: 1,
            }


        ]


    };

export default fields;